import { render, staticRenderFns } from "./_Table.vue?vue&type=template&id=8268d104&scoped=true&"
import script from "./_Table.vue?vue&type=script&lang=js&"
export * from "./_Table.vue?vue&type=script&lang=js&"
import style0 from "./_Table.vue?vue&type=style&index=0&id=8268d104&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8268d104",
  null
  
)

export default component.exports